import React from "react";
import { Box } from "@chakra-ui/react";
import { VeriTabPanelProps } from "./VeriTabPanel.types";

const VeriTabPanel: React.FC<VeriTabPanelProps> = ({ children, ...rest }) => {
  return <Box {...rest}>{children}</Box>;
};

export default VeriTabPanel;
